import { FC } from 'app/FunctionalComponent'
import React from 'react'
import { Badge } from 'ui/components/common/badge/Badge'
import { t } from 'ui/components/i18n/i18n'

export const Required: FC = (props: {}) => {
	return <Badge>{t('component.badge.required')}</Badge>
}
